import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import { Toaster } from "sonner";
import Layout from "./Components/Layout";
import Routing from "./Routing/Routing";

function App() {
  return (
    <>
      <Layout>
        <Routing />
      </Layout>
      <Toaster position="top-right" richColors closeButton />
    </>
  );
}

export default App;
